import type { UserHistoryOperation } from '~/types';

export type GetNotificationsRequest = {
  size?: number;
  page?: number;
};
export type GetNotificationsResponse = {
  items: UserNotificationResponseItem[];
  totalElements: number;
  unread: number;
};

export type UserNotificationResponseItem = {
  _id: string;
  client: { _id: string; name: string } | null;
  users: {
    user: { _id: string; name: string; picture: string; role: string };
    isViewed?: boolean;
  }[];
  orgId: string;
  operation: UserHistoryOperation;
  rolloutIdentifier: string;
  to?: {
    clientUser?: { _id: string; name: string; picture: string; role: string };
  };
  clientTask?: { _id: string; name: string };
  created?: string;
  createdBy: { _id: string; name: string; picture: string; role: string };
  updatedBySystem?: boolean;
};

export type UpdateNotificationViewedRequest = {
  notificationIds: string[];
  isViewed: boolean;
};

export type UpdateNotificationViewedResponse = {};

export function useApiNotification() {
  const { $client } = useNuxtApp();

  const getNotifications = async (
    request: GetNotificationsRequest
  ): Promise<GetNotificationsResponse> => {
    return await $client.notification.getNotifications.query(request);
  };

  const updateNotificationViewedStatus = async (
    request: UpdateNotificationViewedRequest
  ): Promise<UpdateNotificationViewedResponse> => {
    return await $client.notification.updateNotificationViewedStatus.mutate(
      request
    );
  };
  return { getNotifications, updateNotificationViewedStatus };
}
